import Api from "@/repository/ApiBase";
import {GetChannelsResponse} from "@/repository/messagehub.dtos";
import {AxiosResponse} from "axios";

export class WhoAmIApi extends Api{
    constructor() {
        super();

    }
    async getWhoAmI(){
        let result: AxiosResponse =  await this.Client.get('/user/whoami')
        if (result.status == 200){
            return true;
        }
        else{
            return false;
        }
    }
    async getIsEmailMenuVisible(){
        let result: AxiosResponse =  await this.Client.get('/document/email/count')
        if (result.status == 200){
            let count = result.data.count;
            if (count >0){
                return true
            }
            else{
                return false
            }
        }
        else{
            return false;
        }
    }
}
export default WhoAmIApi;
